import Vue from 'vue'
import Router from 'vue-router'
import Shouye from '../components/home/shoye.vue'
import Xiangqing from '../components/home/xiangqing.vue'
import Vip from '../components/home/vip.vue'
import Geren from '../components/geren/gr.vue'
import Mv from '../components/home/mv.vue'
import MvXq from '../components/home/mvxq.vue'
import yhys from '@/components/geren/yhys.vue'
import Qsn from '@/components/geren/qsn.vue'
import Sousuo from '@/components/geren/sousuo.vue'
import Smrz from '@/components/geren/smrz.vue'

Vue.use(Router);
const routes = [
    {
        path: '/',
        name: 'Shouye',
        component: Shouye
    },
    {
        path: '/xiangqing/:id',
        name: 'xiangqing',
        component: Xiangqing    
    },
    {
        path: '/vip',
        name: 'vip',
        component: Vip    
    },
    {
        path: '/geren',
        name: 'geren',
        component: Geren    
    },
    {
        path: '/mv',
        name: 'mv',
        component: Mv    
    },
    {
        path: '/mvxq',
        name: 'mvxq',
        component: MvXq    
    },
    {
        path: '/yhys',
        name: 'yhys',
        component: yhys    
    },
    {
        path: '/qsn',
        name: 'qsn',
        component: Qsn    
    },
    {
        path: '/smrz',
        name: 'smrz',
        component: Smrz    
    },
    {
        path: '/sousuo',
        name: 'sousuo',
        component: Sousuo    
    },
]
const router = new Router({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    const requiresAuth = ['geren']
    const isLoggedIn = !!localStorage.getItem('YousrDL')

    if (requiresAuth.includes(to.name) && !isLoggedIn) {
        alert('请先登录账号')
        next('/')
        return
    }

    next()
})

//修改原型对联 的push 
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;